/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import {
    gql, useMutation
} from "@apollo/client";
import { CircularProgress } from "@mui/material";
import React, { useContext, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { UserContext } from "../ServiceWrapper";


  
  const RegisterUser_Mutation = gql`
    mutation {
        registerUser {
            email,
            displayName,
            subscriptionPlanID
        }
    }
  `;

interface LoginPageProps {
    /*hasAccessToken: Boolean,
    isAuthenticated: Boolean*/
}
const LoginPage: React.FC<LoginPageProps> = ({ }: LoginPageProps) => {
    const navigate = useNavigate();
    const { hasToken, isAuthenticated, currentUser} = useContext(UserContext);
    const [registerUser, { data, loading, error }] = useMutation(RegisterUser_Mutation);
    

    useEffect(() => {
        if (currentUser !== null)
        {
            navigate('/');
        }
        //console.log('login - token: ' + hasToken + ', isAthenticated: ' + isAuthenticated);

    },[currentUser]);

  return (
      <>
        <div style={{display:'flex',width:'100%',height:100,alignItems:'center',justifyContent:'center'}}>
        <CircularProgress/>
          
        </div>
    </>
  );
};

export default LoginPage;